import React, {useState, useContext} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import axios from "axios";
import {InputAdornment} from '@material-ui/core';
import {Search} from '@material-ui/icons';
import {ActionsList, MaskedText, Text} from "../../../controls";
import {useTripSearch} from "../../../services/trips";
import SystemContext from "../../../SystemContext";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
const apiSitePrefix = getApiSitePrefix();

const BookingQueueTrips = (props) => {
  const queryClient = useQueryClient();
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const [state, setState] = useState({
    tripNumber: ""
  });
  const [search, setSearch] = useState({
  });

  const handleTripSearchChange = (searchText) => {
    setState({...state, tripNumber: searchText})
  }

  const delay = (milliseconds) => new Promise(resolve => {
    setTimeout(resolve, milliseconds);
  });

  const download = async (url, name) => {
    const a = document.createElement('a');
    a.download = name;
    a.href = url;
    a.style.display = 'none';
    document.body.append(a);
    a.click();

    // Chrome requires the timeout
    await delay(100);
    a.remove();
  };

  const downloadReport = async (report) => {
    let url;
    let reportName = "";

    try {
      SystemData.toggleLoadingProgress(true);
      switch (report) {
        case "GHA":
          url = `${apiSitePrefix}/booking/exportGhaSheet/${state.tripNumber}`;
          reportName = "GHA Booking Sheet";
          break;
        case "ACCOUNTING":
          url = `${apiSitePrefix}/booking/exportAccountingSheets/${state.tripNumber}`;
          reportName = "Accounting Sheet";
          break;
        case "BACKUP":
          url = `${apiSitePrefix}/booking/exportInvoiceBackup/${state.tripNumber}`;
          reportName = "Invoice Backup";
          break;
      }

      const response = await axios.get(url, {
        headers: {
          //'Access-Control-Allow-Headers': ['Origin', 'X-Requested-With', 'Content-Type', 'Accept'],
          'Access-Control-Allow-Origin': '*',
        }
      });

      if (response && response.data) {
        if (response.data.status) {
          if (__.has(response.data, 'urls') && Array.isArray(response.data.urls)) {
            for (let i=0; i < response.data.urls.length; i++) {
              await delay(i * 200);
              download(response.data.urls[i], response.data.fileNames[i])
            }
          } else {
            download(response.data.excelSignedUrl, response.data.downloadFileName);
          }
        } else {
          SystemData.openAlert(
            "Download Error",
            `The ${reportName} Excel file could not be downloaded due to server error: ${response.data.error}`
          );
        }
      }
      SystemData.toggleLoadingProgress(false);
    } catch {
      SystemData.toggleLoadingProgress(false);
      SystemData.openAlert(
        "Download Error",
        `The ${reportName} Excel file could not be downloaded due to an unexpected error`
      );
    }
  }

  const formatChars={ 
    "A": "[A-Za-z0-9]", 
    "9": "[0-9]", 
  }

  const foundTrip = __.debounce((trip, extraKeys) => {
    const search = extraKeys[0];
    if (trip.tripUuid !== search.tripUuid && search === state.tripNumber) {
      setSearch(trip);
      if (eventBus) {
        eventBus.trigger('BookingQueueTrips.tripSelected', {tripUuid: trip.tripUuid, tripPrefix: trip.tripPrefix, tripNo: trip.tripNo});
      }
    }
  }, 150);
  
  const extraKeys = [state.tripNumber]
  const tripRecord = useTripSearch({queryClient, extraKeys, useCache: true, callback: foundTrip});

  const actions = [
    {iconName: "assessment", iconProps: {color: "secondary"}, tooltip: "Trip Summary", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{eventBus.trigger('BookingQueueTrips.tripSummaryRequested', {})}},
    {iconName: "flight", iconProps: {color: "secondary"}, tooltip: "GHA Extract", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("GHA")}},
    {iconName: "account_balance", iconProps: {color: "secondary"}, tooltip: "Generate Accounting Extract", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("ACCOUNTING")}},
    {iconName: "receipt", iconProps: {color: "secondary"}, tooltip: "Invoice Backup", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("BACKUP")}}
  ]
  

  // const renderActions = () => {
  //   if (actions && Array.isArray(actions)) {
  //     return (
  //       <>
  //         {actions.map((_action) => {
  //           let action = _action;
  //           if (typeof action === "function") {
  //             action = action(tripRecord);
  //           }
  //           if (typeof action.render === "function") {
  //             return action.render(tripRecord, action);
  //           }
  //           return (<IconButton {...__.omit(action, 'iconName')}><Icon {...action.iconProps}>{action.iconName}</Icon></IconButton>)
  //         })}
  //       </>
  //     )
  //   }
  //   return <></>
  // }


  return (
    <div style={{padding: "10px 20px", textAlign: "left", width: "calc(100% - 20px)"}}>
      <div style={{display: "inline-block"}}>
        <MaskedText
          style={{display: "inline-block", width: 130}}
          mask={"AAA99999999"}
          forceUpperCase={true}
          formatChars={formatChars}
          label="Trip Search"
          value={state.tripNumber}
          onChange={handleTripSearchChange}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>        
            )
          }}
        />
        <Text id="tripDate" style={{display: "inline-block", paddingLeft: 30}} label="Date" value={tripRecord?.data?.tripDate}/>
        <Text id="route" style={{display: "inline-block"}}  width={150} label="Route" value={tripRecord?.data?.tripRoute}/>
        <Text id="flight" style={{display: "inline-block"}} width={80} label="Flight" value={`${tripRecord?.data?.airlineCode?tripRecord.data.airlineCode:''}${tripRecord?.data?.flightNo?tripRecord.data.flightNo:''}`}/>
        <Text id="aircraft" style={{display: "inline-block"}} label="Aircraft" value={tripRecord?.data?.aircraftId}/>
      </div>
      <div style={{display: "inline-block"}}></div>
      <div style={{display: "inline-block", float: "right"}}>
        <ActionsList 
          actions={actions}
        />
      </div>
    </div>
  )
}

export default BookingQueueTrips;